import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["children", "parent"];

  static values = {
    url: {
      type: String,
      default: "/app/categories/:category/children?target=:target",
    },
  };

  connect() {
    this.change({ target: this.parentTarget });
  }

  change(event) {
    let category = event.target.value;
    let target = this.childrenTarget.id;

    if (category.trim() === "") {
      return;
    }

    get(
      this.urlValue.replace(":category", category).replace(":target", target),
      {
        responseKind: "turbo-stream",
      },
    );
  }
}
